import {FeatureState} from '../page-data/payloads/header'
import type {FeatureStates} from '../page-data/payloads/header'
import {useLayoutRouteData} from '../page-data/loaders/use-layout-route-data'

const EMPTY_FEATURE_STATES: Readonly<FeatureStates> = Object.freeze({})

export function useFeatureState(feature: keyof FeatureStates): FeatureState {
  const featureStates = useFeatureStates()

  return featureStates[feature] ?? FeatureState.Unavailable
}

export function useFeatureStates(): FeatureStates {
  const {featureStates} = useLayoutRouteData()

  return featureStates ?? EMPTY_FEATURE_STATES
}

export function useIsFeatureStateEnabled(feature: keyof FeatureStates): boolean {
  return useFeatureState(feature) === FeatureState.Enabled
}
